<template>
  <div
    style="
      width: 100%;
      max-width: 500px;
      z-index: 1;
      height: 100%;
      max-height: 300px;
      margin: 0 auto;
    "
  >
    <div class="image-container mb-3" v-if="previewPath">
      <img :src="previewPath" alt="Uploaded Image Preview" />
    </div>
    <div class="form-group">
      <div ref="dashboardContainer"></div>
    </div>
  </div>
</template>

<script>
import Uppy from "@uppy/core";
// import XHRUpload from "@uppy/xhr-upload";
import Dashboard from "@uppy/dashboard";
import AwsS3 from "@uppy/aws-s3";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

export default {
  props: {
    maxFileSizeInBytes: {
      type: Number,
      required: true,
    },
    accepted: {
      type: Object,
      required: true,
    },
    location: {
      type: String,
      required: true,
    },
  },
  mixins: [],
  data() {
    return {
      payload: null,
      previewPath: null,
      disabled: true,
      finish_url: "",
    };
  },
  mounted() {
    // console.log("Uppy");
    this.instantiateUppy();
    // console.log("ACCEPTED: " + this.accepted);
    // console.log("LOCATION: " + this.location);
    // console.log(this.props);
  },
  methods: {
    beforeUpload(files) {
      console.log("Before upload");
      console.log(a);
    },
    instantiateUppy() {
      var location = this.location;
      var that = this;
      this.uppy = Uppy({
        debug: true,
        autoProceed: true,
        onBeforeFileAdded: (currentFile, files) => currentFile,
        onBeforeUpload: files => {
          console.log("Before");
        },
        restrictions: {
          maxFileSize: this.maxFileSizeInBytes,
          minNumberOfFiles: 1,
          maxNumberOfFiles: 1,
          allowedFileTypes: this.accepted,
        },
      })
        .use(Dashboard, {
          height: "200px",
          hideUploadButton: true,
          showLinkToFileUploadResult: false,
          inline: true,
          target: this.$refs.dashboardContainer,
          replaceTargetContent: true,
          showProgressDetails: true,
          browserBackButtonClose: true,
        })
        .use(AwsS3, {
          getUploadParameters(file) {
            // Send a request to our PHP signing endpoint.
            var path =
              process.env.VUE_APP_API_URL +
              "/upload/sign?key=" +
              encodeURIComponent(new Date().getTime() + "-" + file.name.replace(/ /g, ""));
            return fetch(path, {
              method: "get",
              // Send and receive JSON.
              headers: {
                accept: "application/json",
                "content-type": "application/json",
              },
            })
              .then(response => {
                // Parse the JSON response.
                // console.log("RESPONSE");
                // console.log(response);
                return response.json();
              })
              .then(data => {
                console.log("DATA!");
                console.log(data);
                that.finish_url = data.get;
                console.log("FinishURl: " + that.finish_url);
                // Return an object in the correct shape.
                return {
                  method: "PUT",
                  url: data.url,
                  headers: {
                    "Content-Type": file.type,
                  },
                };
              });
          },
        });
      uppy.on("file-added", file => {
        console.log("Added file", file);
      });
      uppy.on("restriction-failed", (file, error) => {
        // do some customized logic like showing system notice to users
        console.log("Restriction failed");
        console.log(file);
        console.log(error);
      });

      this.uppy.on("complete", event => {
        console.log("COMPLETE!", event);
        if (event.successful[0] !== undefined) {
          console.log("emitcomplete", that.finish_url);
          this.$emit("complete", that.finish_url);
          this.uppy.reset();
        }
      });
    },
    finish() {},
    updatePreviewPath({ path }) {
      this.previewPath = path;

      return this;
    },
    resetUploader() {
      this.uppy.reset();
      this.disabled = true;

      return this;
    },
  },
};
</script>

<style scoped>
.image-container {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: auto;
  margin-left: auto;
}

.image-container > img {
  width: inherit;
  height: inherit;
}
</style>
